export { default } from './useConditionalQuery';
